import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { map } from 'rxjs/operators';
import {
  CmxDashboardActiveLoadsCardService,
  JobsiteOption,
  Load
} from '../cmx-dashboard-active-loads-card';

@Component({
  selector: 'cmx-dashboard-jobsite-select',
  templateUrl: './cmx-dashboard-jobsite-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmxDashboardJobsiteSelectComponent {
  @Input()
  public jobsitesPlaceholder: string;

  @Input()
  public searchPlaceholder: string;

  @Input()
  public searchEmptyMessage: string;

  @Input()
  public emptyMessage: string;

  private _customerId: number;
  @Input()
  public set customerId(id: number) {
    this._customerId = id;

    this.onJobsiteChange(null);
    this.ngOnInit();
  }

  public get customerId() {
    return this._customerId;
  }

  @Input()
  public countryCode: string;

  @Input()
  public jobsites: JobsiteOption[] = [];

  @Output()
  public activeJobsiteId = new EventEmitter<string>();

  @Input()
  public activeLoads: Load[] = [];

  @Input()
  public completeLoads: Load[] = [];

  @Input()
  public plannedLoads: Load[] = [];

  @Input()
  public allJobsites: Load[] = [];

  @Input()
  public date: {
    from: string;
    to: string;
  };

  public get jobsites$() {
    return this.service.jobsitesToChoose$.pipe(
      map(js => [{ id: 'ALL', name: this.allJobsites }, ...js])
    );
  }

  public onJobsiteChange(jobsiteId: string) {
    this.handleJobsiteChange(jobsiteId);
  }

  private handleJobsiteChange(jobsiteId: string) {
    if (this.customerId) {
      this.service.fetchNewQueryByJobsite(parseInt(jobsiteId, 10));
      this.activeJobsiteId.emit(jobsiteId);
    }
  }

  public ngOnInit(): void {
    if (this.customerId) {
      this.fetchData(this.customerId, this.countryCode);
    } else {
      this.service.setLoads(
        this.activeLoads,
        this.completeLoads,
        this.plannedLoads
      );
      this.service.setJobsites(this.jobsites);
    }
  }

  private fetchData(customerId: number, countryCode: string) {
    let range = this.date || {
      from: new Date(new Date().setHours(0, 0, 0, 0)) as unknown as string,
      to: new Date(new Date().setHours(23, 59)) as unknown as string
    };

    this.service.fetchInit(customerId, range, countryCode);
  }

  constructor(private service: CmxDashboardActiveLoadsCardService) {}
}
